import {
	SpotLight,
	AmbientLight,
	DirectionalLight,
	ObjectLoader,
	Object3D,
	SpotLightHelper
} from 'three';

export default class LightController {
	constructor(scene, camera, isMobile) {
		// Create Spot A
		// this.SPOT_LIGHT_A = new SpotLight(0xff5555, 1.0);
		// this.SPOT_LIGHT_A.position.set(-100, -100, 100);
		// scene.add(this.SPOT_LIGHT_A);
		// // Create Spot A
		// this.SPOT_LIGHT_B = new SpotLight(0x55ff55, 1.0);
		// this.SPOT_LIGHT_B.position.set(100, -100, 100);
		// scene.add(this.SPOT_LIGHT_B);
		// // Create Ambient
		this.AMBIENT_LIGHT = new AmbientLight(0xfffff, 0.1);
		// scene.add(this.AMBIENT_LIGHT);

		this.SCENE = scene;
		this.OBJECT_LOADER = new ObjectLoader();

		// this.DIRECTIONAL_LIGHT = new DirectionalLight();
		// this.DIRECTIONAL_LIGHT.position.set(1, 2, -1);
		// this.DIRECTIONAL_LIGHT.color.setHex(16777215);
		// this.DIRECTIONAL_LIGHT.intensity = 1;
		// this.DIRECTIONAL_LIGHT.shadow.camera.near = 0.5;
		// this.DIRECTIONAL_LIGHT.shadow.camera.far = 5;
		// this.DIRECTIONAL_LIGHT.shadow.camera.left = -2;
		// this.DIRECTIONAL_LIGHT.shadow.camera.right = 2;
		// this.DIRECTIONAL_LIGHT.shadow.camera.top = 2;
		// this.DIRECTIONAL_LIGHT.shadow.camera.bottom = -2;
		// this.DIRECTIONAL_LIGHT.shadow.radius = 5;
		// this.DIRECTIONAL_LIGHT.shadow.bias = -0.0001;
		// this.DIRECTIONAL_LIGHT.castShadow = true;
		// this.SCENE.add(this.DIRECTIONAL_LIGHT);

		if (!isMobile) {
			this.DOWN_SPOT = new DirectionalLight();
			this.DOWN_SPOT.position.set(0, 3, 0);
			this.DOWN_SPOT.color.setHex(16777215);
			this.DOWN_SPOT.intensity = 1;
			this.DOWN_SPOT.shadow.camera.near = 2;
			this.DOWN_SPOT.shadow.camera.far = 5;
			this.DOWN_SPOT.shadow.camera.left = -0.5;
			this.DOWN_SPOT.shadow.camera.right = 0.5;
			this.DOWN_SPOT.shadow.camera.top = 0.5;
			this.DOWN_SPOT.shadow.camera.bottom = -1;
			this.DOWN_SPOT.shadow.radius = 10;
			this.DOWN_SPOT.shadow.bias = -0.0001;
			this.DOWN_SPOT.shadow.mapSize.width = 512; // default
			this.DOWN_SPOT.shadow.mapSize.height = 512; // default
			this.DOWN_SPOT.castShadow = true;
			this.DOWN_SPOT.angle = Math.PI / 5;
			this.DOWN_SPOT.penumbra = 0.1;
			this.DOWN_SPOT.decay = 1;
			this.SCENE.add(this.DOWN_SPOT);
		}

		// this.AMBIENT_LIGHT = new AmbientLight();
		// this.AMBIENT_LIGHT.color.setHex(14739711);
		// this.AMBIENT_LIGHT.intensity = 0.5386666666666666;

		// this.SPOT_LIGHT = new SpotLight();
		// this.SPOT_LIGHT.position.set(-0.74, 1, 0.6);
		// this.SPOT_LIGHT.color.set(0xffffff);
		// this.SPOT_LIGHT.angle = Math.PI / 5;
		// this.SPOT_LIGHT.penumbra = 0.2;
		// this.SPOT_LIGHT.decay = 2;
		// this.SPOT_LIGHT_TARGET = new Object3D();
		// this.SPOT_LIGHT_TARGET.position.set(0, 1, 0.5);
		// this.SPOT_LIGHT.intensity = 0;

		// this.SPOT_LIGHT.intensity = 0.98475;
		// this.SPOT_LIGHT.shadow.camera.fov = 68.9325;
		// this.SPOT_LIGHT.shadow.camera.near = 0.783;
		// this.SPOT_LIGHT.shadow.camera.far = 500;
		// this.SPOT_LIGHT.shadow.camera.left = -5;
		// this.SPOT_LIGHT.shadow.camera.right = 5;
		// this.SPOT_LIGHT.shadow.camera.top = 5;
		// this.SPOT_LIGHT.shadow.camera.bottom = -5;
		// this.SPOT_LIGHT.castShadow = true;
		// this.SPOT_LIGHT.lookAt(0, 10, 0);

		// this.SPOT_LIGHT.target = this.SPOT_LIGHT_TARGET;
		// this.SCENE.add(this.SPOT_LIGHT.target);
		// this.SCENE.add(this.SPOT_LIGHT);

		// const spotLightHelper = new SpotLightHelper(this.SPOT_LIGHT);
		// this.SCENE.add(spotLightHelper);
	}

	getMobileOperatingSystem() {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;

		// Windows Phone must come first because its UA also contains "Android"
		if (/windows phone/i.test(userAgent)) {
			return 'Windows Phone';
		}

		if (/android/i.test(userAgent)) {
			return 'Android';
		}

		// iOS detection from: http://stackoverflow.com/a/9039885/177710
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			return 'iOS';
		}

		return 'unknown';
	}

	setFromJSON(lights) {
		for (let i = 0; i < lights.length; i += 1) {
			const OBJECT = this.OBJECT_LOADER.parse(lights[i]);
			if (OBJECT.shadow) {
				OBJECT.shadow.mapSize.width = 2048;
				OBJECT.shadow.mapSize.height = 2048;
			}
			// Add
			this.SCENE.add(OBJECT);
		}
	}
}
